const $videoInfoIcons = document.querySelectorAll('.js-video-icon');
const $videoCreditsLayers = document.querySelectorAll('.js-video-credits');

const videoInfoIconClicked = (event) => {
  let $parent = null;

  if (event.target.tagName.toLowerCase() === 'span') {
    $parent = event.target.parentNode.parentNode;
  } else {
    $parent = event.target.parentNode;
  }

  if ($parent !== null) {
    const $credits = $parent.querySelector('.js-video-credits');

    $credits.classList.add('is-active');
  }
};

const videoCreditsLayerClicked = (event) => {
  document.querySelectorAll('.js-video-credits').forEach((item) => item.classList.remove('is-active'));
};

$videoInfoIcons.forEach((item) => item.addEventListener('click', videoInfoIconClicked));
$videoCreditsLayers.forEach((item) => item.addEventListener('click', videoCreditsLayerClicked, true));
